/**
 * @fileoverview BrazeButton with explanation for its enabled/disabled state.
 * Unlike ButtonWithTooltip, this component requires the `label` prop for Operator support.
 */

import React, { forwardRef } from "react";
import type { ReactElement } from "react";

import { UncontrolledTooltip } from "@braze/beacon-core";

import { BrazeButton } from "./BrazeButton";
import type { BrazeButtonWithTooltipProps } from "./types";

export const BrazeButtonWithTooltip = forwardRef<HTMLButtonElement, BrazeButtonWithTooltipProps>(
  function BrazeButtonWithTooltip(
    { disabled, disabledText, enabledText, tooltipProps, ...props },
    ref
  ): ReactElement {
    const button = <BrazeButton ref={ref} disabled={disabled} {...props} />;

    if (disabled && !!disabledText) {
      return (
        <UncontrolledTooltip label={disabledText} {...tooltipProps}>
          {button}
        </UncontrolledTooltip>
      );
    }

    if (!disabled && !!enabledText) {
      return (
        <UncontrolledTooltip label={enabledText} {...tooltipProps}>
          {button}
        </UncontrolledTooltip>
      );
    }

    return button;
  }
);
